import { gql } from '@apollo/client';
import { useEffect, useMemo, useState } from 'react';
import { DataUser } from 'src/common/interfaces';
import { getMstUser } from 'src/graphql/queries';
import { useAppLazyQuery } from 'src/libs/hooks';

const ModalGuideUser = ({
  setIsOpen,
  onCallbackFunction,
}: {
  setIsOpen: (isOpen: boolean) => void;
  onCallbackFunction: (item: DataUser) => void;
}) => {
  const header = ['ユーザコード', 'ユーザ名'];
  const [dataUser, setDataUser] = useState<Array<DataUser>>([]);
  const [inforUserCd, setInforUserCd] = useState<string>('');
  const [inforUserMn, setInforUserMn] = useState<string>('');

  const [searchDataUser, { data: listDataUser, loading: isListDataUserLoading }] = useAppLazyQuery({
    query: gql(getMstUser),
  });

  const renderTableHeader = () => {
    return header.map((key, index) => (
      <th
        className="whitespace-nowrap p-[8px] sticky top-0 border-[1px] border-solid border-[#ddd] pt-[12px] pb-[12px] text-center bg-blue-400 text-[#fff]"
        key={index}
      >
        {key.toUpperCase()}
      </th>
    ));
  };

  const onClickItemUser = (dataUser: DataUser) => {
    onCallbackFunction(dataUser);
    setIsOpen(false);
  };

  const renderTableData = useMemo(() => {
    if (dataUser?.length <= 0 || !dataUser) return;
    return dataUser.map((inforUser: DataUser, index: number) => {
      return (
        <tr key={index}>
          <td className="p-[8px] border-[1px] border-solid border-[#ddd]">
            <p>{inforUser?.mu_user_id}</p>
          </td>
          <td className="p-[8px] border-[1px] border-solid border-[#ddd] text-blue-600 cursor-pointer">
            <p onClick={() => onClickItemUser(inforUser)}>{inforUser?.mu_user_nm}</p>
          </td>
        </tr>
      );
    });
  }, [dataUser]);

  const onPressSearch = () => {
    const params = {
      mu_user_id: inforUserCd === '' ? null : inforUserCd,
      mu_user_nm: inforUserMn,
    };
    searchDataUser({ variables: { input: params } });
  };

  useEffect(() => {
    const newDataUser = { ...listDataUser };
    const listNewDataUser: DataUser[] =
      newDataUser?.getMstUser?.sort((user1: any, user2: any) => {
        return user1.mu_user_id - user2.mu_user_id;
      }) || [];
    setDataUser(listNewDataUser);
  }, [listDataUser]);

  return (
    <div className="fixed w-full h-full inset-0 flex items-center justify-center">
      <div className="bg-[#00000030] w-full h-full z-[0] inset-0 fixed" />
      <div className="flex fixed bg-white h-4/6 w-1/3 items-center flex-col z-[1] overflow-auto">
        <div className="w-5/6 flex justify-end items-center mt-[10px]">
          <button onClick={() => setIsOpen(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="h-[40px] w-4/5 flex justify-center items-center border border-zinc-300 mt-[50px]">
          <div className="h-full w-2/5 flex justify-center items-center bg-blue-400 text-white">ユーザコード</div>
          <div className="h-full w-3/5 flex justify-center items-center">
            <input
              className="bg-transparent pl-[5px] h-[40px] w-full pr-[5px] "
              onChange={(event) => {
                if (event.target.value.length > 4) return;
                setInforUserCd(event?.target?.value);
              }}
              type="number"
              name="infor_user_cd"
              value={inforUserCd}
              min={0}
            />
          </div>
        </div>
        <div className="h-[40px] w-4/5 flex justify-center items-center border border-zinc-300 mt-[10px]">
          <div className="h-full w-2/5 flex justify-center items-center bg-blue-400 text-white">ユーザ名</div>
          <div className="h-full w-3/5 flex justify-center items-center">
            <input
              className="bg-transparent pl-[5px] h-[40px] w-full"
              onChange={(event) => {
                if (event.target.value.length > 50) return;
                setInforUserMn(event?.target?.value);
              }}
              type="text"
              name="infor_user_nm"
              value={inforUserMn}
            />
          </div>
        </div>
        <div className="h-[40px] w-4/5	flex justify-end items-center mt-[10px] ">
          <button
            onClick={onPressSearch}
            className="border border-zinc-300 h-[40px] w-[100px] justify-center items-center flex"
          >
            <p>検索</p>
          </button>
        </div>
        <div className="overflow-auto max-h-100 w-4/5 mt-[20px] mb-[20px]">
          <table className="text-center border-collapse border-[3px] border-solid border-[#ddd] w-full td:p-[10px]  ">
            <thead>
              <tr>{renderTableHeader()}</tr>
            </thead>
            <tbody>
              {isListDataUserLoading ? (
                <tr>
                  <td
                    colSpan={header.length}
                    className="text-center animate-pulse p-[8px] border-[1px] border-solid border-[#fff]"
                  >
                    Loading...
                  </td>
                </tr>
              ) : (
                renderTableData
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ModalGuideUser;
